import Logo from '../navbar/Logo';
import DashboardNavigationList from './DashboardNavigationList';

import { AppRoutes } from '@/interfaces/routes/AppRoutes';

const DashboardSidebar = () => {
	return (
		<div
			className="flex flex-col w-60 relative p-4 rounded bg-white border-r gap-4 overflow-auto h-full"
			data-test="admin-sidebar"
		>
			<div className="flex justify-center w-full">
				<Logo href={AppRoutes.Landing} width={320} height={42} />
			</div>
			{/* <div className="my-4">
				{!isAdminUser &&
					(tradeName.length > 0 ? (
						<ShareUrl storeName={tradeName} />
					) : (
						<div className="text-sm" data-test="trade-name-not-found">
							Trade name is required to share the URL
						</div>
					))}
			</div> */}
			<div className="overflow-y-auto">
				<DashboardNavigationList />
			</div>
		</div>
	);
};

export default DashboardSidebar;
